import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheveronUpDown = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.4697 5.34467C11.7626 5.05178 12.2374 5.05178 12.5303 5.34467L15.6553 8.46967C15.9482 8.76256 15.9482 9.23744 15.6553 9.53033C15.3624 9.82322 14.8876 9.82322 14.5947 9.53033L12 6.93566L9.40533 9.53033C9.11244 9.82322 8.63756 9.82322 8.34467 9.53033C8.05178 9.23744 8.05178 8.76256 8.34467 8.46967L11.4697 5.34467ZM8.34467 14.4697C8.63756 14.1768 9.11244 14.1768 9.40533 14.4697L12 17.0643L14.5947 14.4697C14.8876 14.1768 15.3624 14.1768 15.6553 14.4697C15.9482 14.7626 15.9482 15.2374 15.6553 15.5303L12.5303 18.6553C12.2374 18.9482 11.7626 18.9482 11.4697 18.6553L8.34467 15.5303C8.05178 15.2374 8.05178 14.7626 8.34467 14.4697Z",
		fill: "currentcolor"
	})]
});
export default SvgCheveronUpDown;
